import React from 'react'
import classNames from 'classnames'
import { Popover } from 'antd'
import Icon from 'meinian-package/src/component/icon'
import styles from '../index.module.less'

export const VIEW_MODE = { PLAT: 1, COLUMN: 2, MULTI: 3 }

export default ({
  className,
  style,
  onViewMode,
  viewMode,
}) => {
  const content = (<div className={styles.styleSwitchingViewContent}>
    <div
      className={classNames('view-mode-item-wrap', 'fill-white-bg', { active: viewMode === VIEW_MODE.PLAT })}
      onClick={() => {
        onViewMode(VIEW_MODE.PLAT)
      }}
    >
      <div className="view-mode-item">
        <Icon type="m-kapianmoshi" className="view-mode-item-icon" />
        <span>单图模式</span>
      </div>
    </div>
    <div
      className={classNames('view-mode-item-wrap', 'fill-white-bg', { active: viewMode === VIEW_MODE.MULTI })}
      onClick={() => {
        onViewMode(VIEW_MODE.MULTI)
      }}
    >
      <div className="view-mode-item">
        <Icon type="m-pubuliu" className="view-mode-item-icon" />
        <span>多图模式</span>
      </div>
    </div>
    <div
      className={classNames('view-mode-item-wrap', 'fill-white-bg', { active: viewMode === VIEW_MODE.COLUMN })}
      onClick={() => {
        onViewMode(VIEW_MODE.COLUMN)
      }}
    >
      <div className="view-mode-item">
        <Icon type="m-liebiaomoshi" className="view-mode-item-icon" />
        <span>列表模式</span>
      </div>
    </div>
  </div>)
  return <div className={classNames(styles.styleSwitchingView, className)} style={style}>
    <Popover
      placement="left"
      content={content}
      trigger="click"
      overlayClassName={styles['styleSwitchingViewText-popover']}
    >
      <div className="styleSwitchingViewText fill-white-bg">视图切换</div>
    </Popover>
  </div>
}
